import axios from 'axios'
import store from '@/store'
import { Message } from 'element-ui'
import i18n from '@/i18n'

/**
 * @typedef {import('axios').AxiosResponse} ApiResponse
 * @property {Object} data
 */
// create an axios instance
const service = axios.create({
  baseURL: `${process.env.VUE_APP_API}/customer`, // api base_url
  timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    if (store.getters.token) {
      config.headers['Authorization'] = `bearer ${store.getters.token}`
    }
    return config
  },
  error => {
    if (process.env.NODE_ENV === 'development') {
      console.log(error) // for debug
    }
    // Do something with request error
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => response.data.data,
  error => {
    if (process.env.NODE_ENV === 'development') {
      console.log(error, error.response) // for debug
    }

    if (error && error.response.status === 401) {
      Message({
        message: error.response.data.info,
        type: 'error',
        duration: 5 * 1000
      })
      store.dispatch('AuthTokenExpired').then(() => {
        // location.href = '/'
      })
    } else {
      const message = (error.response.data.error && error.response.data.error.message) ? error.response.data.error.message : error.response.data.info
      if (message === 'El cliente proporcionado no existe.') {
        console.log('here')
        Message({
          message: i18n.t('messages.tasksNotFounds'),
          type: 'success',
          duration: 5 * 1000
        })
      } else {
        Message({
          message: (error.response.data.error && error.response.data.error.message) ? error.response.data.error.message : error.response.data.info,
          type: 'error',
          duration: 5 * 1000
        })
      }
    }
    return Promise.reject(error)
  }
)

export default service
